import { useEffect, useState } from "react";

import { generateJsonTreeLines, JsonValue } from "~/components/json-tree-viewer.utils";

export type JsonTreeLinesState =
  | { status: "loading" }
  | { status: "success"; value: ReturnType<typeof generateJsonTreeLines> }
  | { status: "error"; error: unknown };

export function useJsonTreeLines(data: JsonValue, expandedIds: Set<string>) {
  const [jsonTreeLinesState, setJsonTreeLinesState] = useState<JsonTreeLinesState>({
    status: "loading",
  });

  useEffect(() => {
    const worker = new Worker(new URL("~/workers/generate-json-tree-lines.worker.ts", import.meta.url), {
      type: "module",
    });
    const controller = new AbortController();
    worker.onmessage = (
      e: MessageEvent<
        { type: "success"; result: ReturnType<typeof generateJsonTreeLines> } | { type: "error"; error: unknown }
      >,
    ) => {
      if (controller.signal.aborted) {
        worker.terminate();
        return;
      }
      if (e.data.type === "success") {
        setJsonTreeLinesState({ status: "success", value: e.data.result });
      }
      if (e.data.type === "error") {
        setJsonTreeLinesState({ status: "error", error: e.data.error });
      }
      worker.terminate();
    };

    worker.postMessage({ data, expandedIds });

    return () => {
      controller.abort();
      worker.terminate();
    };
  }, [data, expandedIds]);

  return jsonTreeLinesState;
}
